import { formatDate } from 'mixins/helpers';

export const columnsSearch = [
    {
        title: 'Дата постановки (последней постановки на учет по НДС)',
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (item) => formatDate(item),
    },
    {
        title: 'Дата снятия (последнего снятия) с учета НДС',
        dataIndex: 'endDate',
        key: 'endDate',
        render: (item) => formatDate(item),
    },
    {
        title: 'Причина снятия (последнего снятия) с учета по НДС',
        dataIndex: 'reason',
        key: 'reason',
        render: (item) => item || '-',
    },
];

export const columnsCheck = [
    {
        title: 'Дата постановки (последней постановки на учет по НДС)',
        dataIndex: 'beginDate',
        key: 'beginDate',
        width: '150px',
        render: (item) => formatDate(item),
    },
    {
        title: 'Дата снятия (последнего снятия) с учета НДС',
        dataIndex: 'endDate',
        key: 'endDate',
        width: '200px',
        render: (item) => formatDate(item),
    },
    {
        title: 'Причина снятия (последнего снятия) с учета по НДС',
        dataIndex: 'reason',
        key: 'reason',
        width: '150px',
        render: (item) => item || '-',
    },
    {
        title: 'Номер свидетельства',
        dataIndex: ['certificateInfo', 'number'],
        key: 'certificateInfo.number',
        render: (item) => item || '-',
    },
    {
        title: 'Серия свидетельства',
        dataIndex: ['certificateInfo', 'series'],
        key: 'certificateInfo.series',
        render: (item) => item || '-',
    },
    {
        title: 'Дата выдачи свидетельства',
        dataIndex: ['certificateInfo', 'beginDate'],
        key: 'certificateInfo.beginDate',
        render: (item) => formatDate(item),
    },
    {
        title: 'Дата регистрации',
        dataIndex: 'responseDate',
        key: 'responseDate',
        render: (item) => formatDate(item),
    },
    {
        title: 'Статус',
        dataIndex: ['certificateInfo', 'status'],
        key: 'certificateInfo.status',
        render: (item) => item || '-',
        width: '150px',
    },
];
